import { useLocation, useNavigate, useParams, Navigate } from 'react-router-dom';

import { CardShell } from '@shared/ui/CardShell';

import { ContractCard } from './ContractCard';

/**
 * Полноценная страница карточки договора по URL
 * `/agents/statut/contracts/:id` или `/agents/statut/precontracts/:id`.
 * Карточка одна на оба реестра (общий анализ/риски) — различается только
 * реестр, из которого пришли. Возврат ведёт в тот же реестр, откуда открыли.
 * См. ClaimPage для контекста перехода с модалок на страницы.
 */
export function ContractPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  // /agents/statut/<precontracts|contracts>/:id — сегмент [3] задаёт реестр
  // (['', 'agents', 'statut', '<registry>', ':id']).
  const registry = location.pathname.split('/')[3] === 'precontracts' ? 'precontracts' : 'contracts';
  const registryPath = `/agents/statut/${registry}`;

  if (!id) {
    return <Navigate to={registryPath} replace />;
  }

  const back = () => navigate(registryPath);

  return (
    <CardShell title="Карточка договора" onBack={back}>
      <ContractCard contractId={id} onClose={back} />
    </CardShell>
  );
}
